module.exports = __webpack_public_path__ + "static/img/img_care_center.911f691.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_care_center.jpg
// module id = hRlD
// module chunks = 0